<template>
  <NotFound></NotFound>
</template>

<script>

  import NotFound from "@/components/Common/NotFound";

  export default {
    components: {NotFound}
  }
</script>

<style scoped>

</style>